<template>
  <div class="detail-layout">
    <div class="detail-main">
      <div class="serm-pointer"><a href="#">招商中心</a>&gt;<a href="#">{{path.parent}}</a>
        <template v-if="path.children">
          &gt;<a href="#">{{path.children}}</a>
        </template> 
      </div>
      <h1>{{detail.courseName}}</h1>
      <div v-html="detail.content" class="detail-content" v-if="detail.content"></div>
      <video :src="detail.courseVideoUrl" :controls="true" v-else-if="detail.courseVideoUrl">
        您的浏览器不支持 video 标签。
      </video>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
export default {
  data(){
    return {
      path:{
        parent:'',
        children:''
      },
      detail: {}
    }
  },
  computed:{
    ...mapState('canvass',['menuList'])
  },
  mounted(){
      const id = this.$route.query.id
      this.getPath(id)
  },
  methods:{
    ...mapActions('canvass',['queryCourseById']),
    async getDetailById(id){
      const res = await this.queryCourseById({id})
      if (res.code == 0) {
        this.detail = res.data
      }
      return res.data;
    },
    async getPath(id){
      const res = await this.getDetailById(id);
      const linkCargoryId = res && res.linkCargoryId
      for(let item of this.menuList) {
        if (item.children && item.children.length > 0) {
          for(let el of item.children) {
            if (el.id == linkCargoryId) {
              this.path.children = el.title
              this.path.parent = item.title
              this.$store.commit('canvass/setMutations', {data:el.id,nameSpace:'linkCargoryId'})
              this.$store.commit('canvass/setMutations', {data:[item.id],nameSpace:'openKeys'})
              break
            }
          }
        } else {
          if (item.id == linkCargoryId) {
            this.path.parent = item.title
            this.$store.commit('canvass/setMutations', {data:item.id,nameSpace:'linkCargoryId'})
          }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.detail-layout {
  padding-bottom: 15px;
  text-align: left;
  .detail-main {
    min-height: calc(100vh - 290px);
    background-color: #fff;
    padding: 20px;
    .serm-pointer {
      color: #666;
      a {
        margin: 0 5px;
        text-decoration: none;
        color: #666;
      }
    }
    h1 {
      padding: 20px 0;
      border-bottom: 1px dashed #EEE;
      font-size: 18px;
      color: #333333;
      position: relative;
      text-align: center;
      line-height: 22px;
      font-weight: bold;
    }
    .detail-content {
      padding-top: 20px;
    }
  }
}
</style>

